import { createTheme } from "@mui/material";
import { grey } from "@mui/material/colors";
import { SBTheme } from "sonobello.utilities.react.mui";

const theme = createTheme(SBTheme, {
  palette: { action: { selected: grey[200] } }
});

export default theme;
